var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.craftSupplier)?_c('div',{staticClass:"flex gap-2"},[_c('img',{staticClass:"flex-none object-cover",attrs:{"width":"100px","src":_vm.craftSupplier.supplier_thumbnail,"alt":_vm.craftSupplier.title}}),_vm._v(" "),_c('div',[_c('h4',[_vm._v(_vm._s(_vm.craftSupplier.title))]),_vm._v(" "),(
        _vm.odysseySupplier &&
        _vm.odysseySupplier.rating &&
        _vm.odysseySupplier.rating.aggregated_rating
      )?_c('div',{staticClass:"mt-2 flex items-end"},[_c('rating',{staticClass:"mr-1",attrs:{"value":_vm.odysseySupplier.rating.aggregated_rating.supplier_rating,"size":"28"}})],1):_vm._e()])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }